import get from 'lodash.get';

const getRequestBlock = (rootState) => get(rootState, 'ws.integration.settings.requestBlock', null);

export default getRequestBlock;
